document.addEventListener("DOMContentLoaded", function () {  
	/*====================================================
		Site language and country detection for VAT
	====================================================*/
	let isFrench = false;
	if (document.documentElement.lang === "fr") {
		isFrench = true;
	}
	
	function updateProductCardPrices() {
		const productCardPrices = document.querySelectorAll('.js-product-card-price');
		productCardPrices.forEach(priceElement => {
			const originalPrice = parseFloat(priceElement.getAttribute('data-price'));
			if (!isNaN(originalPrice)) {
				priceElement.textContent = originalPrice.toFixed(2) + ' €';
			}
		});
	}
	
	// Run the price update
	updateProductCardPrices();

	/*====================================================
		CARD
	====================================================*/
	// has-variants buttons open the variant modal
	document.querySelectorAll(".card-add-to-cart-btn.has-variants").forEach((btn) => {
		btn.addEventListener("click", function () {
			const productHandle = this.getAttribute("data-product-handle");
			const productModalId = this.getAttribute("data-modal-id");
			openVariantModal(productModalId, productHandle);
		});
	});

	// Form submit handler for all card add-to-cart forms (no-variants + modal)
	document.addEventListener('submit', function (event) {
		if (!event.target.matches('[data-type="card-add-to-cart-form"]')) return;
		event.preventDefault();
		const form = event.target;
		const variantId = form.querySelector('[name="id"]').value;
		const button = form.querySelector('.card-add-to-cart-btn, .modal-add-to-cart-btn');
		const modalId = form.dataset.modalId || null;
		addToCart(button, variantId, modalId);
	});

	/*====================================================
		MODAL
	====================================================*/
	/**
	 * Open /close variant modal
	 */
	function openVariantModal(productModalId, productHandle) {
		let currentModal = document.getElementById('variant-modal-' + productModalId);
		let modalSelects = currentModal.querySelectorAll('select');
		let addToCartBtn = currentModal.querySelector('.modal-add-to-cart-btn');
		let variantIdInput = currentModal.querySelector('.js-modal-variant-id');

		// Show modal.
		currentModal.classList.remove('hidden');

		// Close handlers (idempotent: listeners stored on node to avoid duplicate binding).
		const closeBtn = currentModal.querySelector('.close-modal');
		const modalWrapper = currentModal.querySelector('.modal-wrapper');
		const modalContent = currentModal.querySelector('.modal-content');

		const closeHandler = () => closeVariantModal(productModalId);
		const backdropHandler = (e) => {
			if (modalContent && !modalContent.contains(e.target)) closeVariantModal(productModalId);
		};
		const escHandler = (e) => {
			if (e.key === 'Escape' && !currentModal.classList.contains('hidden')) {
				closeVariantModal(productModalId);
			}
		};

		if (!currentModal._closeBound) {
			if (closeBtn) closeBtn.addEventListener('click', closeHandler);
			if (modalWrapper) modalWrapper.addEventListener('click', backdropHandler);
			document.addEventListener('keydown', escHandler);
			currentModal._closeBound = true;
			currentModal._escHandler = escHandler;
		}

		// Get all products variants.
		const variantsData = {};
		currentModal.querySelectorAll('span[data-variant-id]').forEach((element) => {
			const variantId = element.getAttribute('data-variant-id');
			const variantQuantity = parseInt(element.getAttribute('data-variant-quantity'), 10);
			variantsData[variantId] = variantQuantity;
		});

		// Handle variants change: update price, stock, and hidden variant ID input.
		modalSelects.forEach(select => {
			select.addEventListener('change', () => {
				updateVariantInfo(productHandle, variantsData, currentModal, modalSelects, addToCartBtn, variantIdInput);
			});
		});

		// Initialize hidden input and price with currently selected options.
		updateVariantInfo(productHandle, variantsData, currentModal, modalSelects, addToCartBtn, variantIdInput);
	}

	function closeVariantModal(productModalId) {
		document.getElementById('variant-modal-' + productModalId).classList.add('hidden');
	}

	/*====================================================
		VARIANTS
	====================================================*/
	/**
	 * Function to update stock and price based on selected options
	 */
	async function updateVariantInfo(productHandle, variantsData, currentModal, modalSelects, addToCartButton, variantIdInput) {
		const productData = await getProductByHandle(productHandle);
		const selectedOptions = Array.from(modalSelects).map(select => select.value);
		const selectedVariantId = await getVariantIdFromOptions(productHandle, selectedOptions);

		if (selectedVariantId && variantsData[selectedVariantId] !== undefined) {
			const stockQuantity = variantsData[selectedVariantId];

			if(stockQuantity > 0) {
				addToCartButton.disabled = false;
				addToCartButton.classList.remove("disabled");
			} else {
				addToCartButton.disabled = true;
				addToCartButton.classList.add("disabled");
			}

			// Update the hidden variant ID input in the form
			if (variantIdInput) variantIdInput.value = selectedVariantId;

			// Update the price based on selected variant
			const selectedVariant = productData.variants.find(variant => variant.id == selectedVariantId);
			if (selectedVariant) {
				updatePrice(selectedVariant, currentModal);
			}
		}
	}

	/**
	 * Function to get variant ID from selected options
	 */
	async function getVariantIdFromOptions(productHandle, selectedOptions) {
		let currentProduct = await getProductByHandle(productHandle);

		return currentProduct.variants.find(variant =>
			variant.options.every((option, index) => option === selectedOptions[index])
		)?.id;
	}

	/**
	 * Get product object by handle.
	 */
	function getProductByHandle(productHandle) {
		return fetch(`/products/${productHandle}.js`)
			.then(response => response.json())
			.then(product => {
				return product;
			})
			.catch(error => {
				console.error("Error fetching product:", error);
				return null;
			});
	}

	/**
	 * Function to update the price
	 */
	function updatePrice(selectedVariant, currentModal) {
		const price = parseFloat(selectedVariant.price);
		const compareAtPrice = parseFloat(selectedVariant.compare_at_price);
		
		// Convert cents to euros
		const priceWithoutVAT = price / 100;
		const compareAtPriceWithoutVAT = compareAtPrice ? compareAtPrice / 100 : 0;

		// Format prices
		const formattedPrice = priceWithoutVAT.toFixed(2) + ' €';
		const formattedCompareAtPrice = compareAtPriceWithoutVAT.toFixed(2) + ' €';
		
		// Get price elements
		const regularPriceElement = currentModal.querySelector('.product-price-regular');
		const salePriceElement = currentModal.querySelector('.product-price-sale');
		const currentPriceElement = currentModal.querySelector('.product-price-current');
		const originalPriceElement = currentModal.querySelector('.product-price-original');

		// Update the dynamic price container with the variant ID
		const dynamicPriceContainer = currentModal.querySelector('.modal-dynamic-price');
		if (dynamicPriceContainer) {
			dynamicPriceContainer.setAttribute('data-variant-id', selectedVariant.id);
			
			// Update data-price attributes for VAT calculation
			const modalPriceRegular = dynamicPriceContainer.querySelector('.modal-price-regular');
			const modalPriceSale = dynamicPriceContainer.querySelector('.modal-price-sale');
			const modalPriceCompare = dynamicPriceContainer.querySelector('.modal-price-compare');
			
			if (modalPriceRegular) modalPriceRegular.setAttribute('data-price', priceWithoutVAT);
			if (modalPriceSale) modalPriceSale.setAttribute('data-price', priceWithoutVAT);
			if (modalPriceCompare) modalPriceCompare.setAttribute('data-price', compareAtPriceWithoutVAT);
		}

		if (compareAtPrice && price < compareAtPrice) {
			// Show sale price
			salePriceElement.style.display = 'flex';
			regularPriceElement.style.display = 'none';
			currentPriceElement.textContent = formattedPrice;
			originalPriceElement.textContent = formattedCompareAtPrice;
		} else {
			// Show regular price
			salePriceElement.style.display = 'none';
			regularPriceElement.style.display = 'inline';
			regularPriceElement.textContent = formattedPrice;
		}
	}

	/*====================================================
		ADD TO CART
	====================================================*/
	/**
	 * Function to add a product to the cart
	 */
	function addToCart(button, variantId, productModalId) {
		let cartIcon = button.querySelector('.cart-icon');
		let cartIconLoading = button.querySelector('.cart-icon-loading');
		let toastDuration = 6000;
		let toastMessage = isFrench ? 'Produit ajouté au panier !' : 'Product added to cart!';
		let toastBtnLabel = isFrench ? 'Voir le panier' : 'Go to cart';
		let toastMessageError = isFrench ? 'Erreur, le produit n\'a pas pu être ajouté au panier.' : 'Error: Product could not be added to cart.';

		toggleCartIcons(true, cartIcon, cartIconLoading);

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
			},
			body: JSON.stringify({ 
				id: variantId, 
				quantity: 1,
			})
		})
		.then(response => response.json())
		.then(data => {
			updateCartCount();
			toggleCartIcons(false, cartIcon, cartIconLoading);
			if(productModalId) {
				closeVariantModal(productModalId);
			}
			document.dispatchEvent(new CustomEvent('cart:item-added'));
		})
		.catch(error => {
			showToast(toastDuration, 'error', toastMessageError);
			console.error('Error:', error);
			toggleCartIcons(false, cartIcon, cartIconLoading);
		});
	}

	/**
	 * Function to toggle cart icon visibility
	 */
	function toggleCartIcons(isLoading, cartIcon, cartIconLoading) {
		if (!cartIconLoading) return;
		if (isLoading) {
			if (cartIcon) cartIcon.style.display = 'none';
			cartIconLoading.style.display = 'block';
		} else {
			if (cartIcon) cartIcon.style.display = '';
			cartIconLoading.style.display = 'none';
		}
	}

	/**
	 * Function to update the cart count in the bubble
	 */
	function updateCartCount() {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				const cartCountElement = document.querySelectorAll(".js_cart-count");
				const totalItems = cart.items.reduce((acc, item) => acc + item.quantity, 0);
				cartCountElement.forEach((count) => {
					count.textContent = totalItems;
					let cartBubble = count.closest('.cart-count-bubble');
					if (cartBubble.classList.contains('hidden')) {
						cartBubble.classList.add('flex');
						cartBubble.classList.remove('hidden');
					}
				});
			});
	}

	/*====================================================
		TOAST
	====================================================*/
    /**
	 * Function to show toast message
	 * @param {int} duration Toast display time.
	 * @param {string} type 'success' or 'error.
	 * @param {string} message The message to display in the toast.
	 * @param {object} link 'url' and 'label' to display a link button.
	 */
	function showToast(duration, type, message, link = null) {
		const toastContainer = document.createElement('div');
		toastContainer.className = 'toast-container';
		document.body.appendChild(toastContainer);

		const toast = document.createElement('div');
		toast.className = 'toast';

		// Add class based on the toast type (success or error)
		if (type === 'success') {
			toast.classList.add('success');
		} else if (type === 'error') {
			toast.classList.add('error');
		}

		// Add the message text
		const messageElement = document.createElement('span');
		messageElement.textContent = message;
		toast.appendChild(messageElement);

		// Add the link button if the link parameter is provided
		if (link && link.url && link.label) {
			const linkButton = document.createElement('a');
			linkButton.href = link.url;
			linkButton.textContent = link.label;
			linkButton.className = 'toast-link';
			toast.appendChild(linkButton);
		}

		toastContainer.appendChild(toast);

		// Automatically remove the toast after a duration
		setTimeout(() => {
			toastContainer.classList.add('opacity-0');
			setTimeout(() => {
				toastContainer.remove();
				toast.remove();
			}, 300); // Matches the fade-out transition duration
		}, duration);
	}
});

/**
 * Quick-add modale: toggle binaire -> select cache (scope global pour onclick inline).
 * Equivalent a updateOptionValue de main-product.liquid.
 */
function updateQuickAddOptionValue(element) {
	const checkbox = element;
	const blocParent = checkbox.parentElement;
	const select = blocParent.querySelector('.mm-select-option');
	if (!select) return;
	select.value = checkbox.checked ? checkbox.dataset.value2 : checkbox.dataset.value1;
	select.dispatchEvent(new Event('change'));
}
